export default {
    text: 'Fantasy',
    path: '/fantasy',
    icon: 'fantasy.svg',
    permissions: {
        FANTASY_ADMIN: 'READ'
    },
    children: [
        {
            text: 'Tournaments',
            path: '/fantasy/tournaments',
            children: [],
            permissions: {
                FANTASY_ADMIN: 'READ'
            }
        },
        {
            text: 'Teams',
            path: '/fantasy/teams',
            children: [],
            permissions: {
                FANTASY_ADMIN: 'READ'
            }
        },
        {
            text: 'Players',
            path: '/fantasy/players',
            children: [],
            permissions: {
                FANTASY_ADMIN: 'READ'
            }
        },
        {
            text: 'Matches',
            path: '/fantasy/matches',
            children: [],
            permissions: {
                FANTASY_ADMIN: 'READ'
            }
        }
    ]
};
